'use client'

import { createContext, type ReactNode, useContext } from 'react'

import { DEFAULT_LOCALE, type Locale } from '@/lib/i18n/config'

const LocaleContext = createContext<Locale>(DEFAULT_LOCALE)

/**
 * The reader's locale for client components, set by each root that knows
 * it: the marketing root from its URL, the signed-in providers from the
 * visitor's preference. Outside one (a test, a root that has not adopted it
 * yet) text formats in English.
 */
export function LocaleProvider({
  locale,
  children,
}: {
  locale: Locale
  children: ReactNode
}) {
  return (
    <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>
  )
}

/** The locale a client component formats numbers, dates and lists in. */
export function useAppLocale(): Locale {
  return useContext(LocaleContext)
}
